// extracted by mini-css-extract-plugin
module.exports = {"header":"ModalInfo_header__YzWIh","footer":"ModalInfo_footer__3rs8m"};